var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.error === ""
    ? _c(
        "div",
        [
          _c("gg-card-title", [
            _vm._v(" Promo Request #" + _vm._s(_vm.promoRequestId) + " ")
          ]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "gg-loading",
                    {
                      staticClass: "fill-height",
                      attrs: {
                        loading: !_vm.promoTitleLoaded,
                        type: "article"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "app-card fill-height"
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-list",
                                [
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _c("strong", [
                                              _vm._v("Promo Name:")
                                            ])
                                          ])
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-action", [
                                        _vm._v(_vm._s(_vm.promo.promo_name))
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _c("strong", [
                                              _vm._v("Promo Status:")
                                            ])
                                          ])
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-action", [
                                        _vm._v(_vm._s(_vm.heading))
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _c("strong", [
                                              _vm._v("Payment Amount:")
                                            ])
                                          ])
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-action", [
                                        _c("b", [
                                          _vm._v(
                                            "$" + _vm._s(_vm.promoPaymentAmount)
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm.promoInvoiceID
                                    ? _c(
                                        "v-list-item",
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _c("strong", [
                                                  _vm._v("Invoice ID:")
                                                ])
                                              ])
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-action", [
                                            _c("b", [
                                              _vm._v(
                                                "#" + _vm._s(_vm.promoInvoiceID)
                                              )
                                            ])
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "gg-loading",
                    {
                      staticClass: "fill-height",
                      attrs: {
                        loading: !_vm.promoTitleLoaded,
                        type: "article"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "app-card fill-height"
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-list",
                                [
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _c("strong", [_vm._v("Service:")])
                                          ])
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-action", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.promoServiceFormatted) +
                                            " "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _c("strong", [
                                              _vm._v("Date Requested:")
                                            ])
                                          ])
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-action", [
                                        _vm._v(_vm._s(_vm.promoDate))
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm.promoDateCompleted
                                    ? _c(
                                        "v-list-item",
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _c("strong", [
                                                  _vm._v("Date Completed:")
                                                ])
                                              ])
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-action", [
                                            _vm._v(
                                              _vm._s(_vm.promoDateCompleted)
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-loading",
                    {
                      attrs: {
                        loading: !_vm.promoTitleLoaded,
                        type: "article"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "app-card"
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("h3", [
                                _vm._v(" " + _vm._s(_vm.heading) + " ")
                              ]),
                              _c(_vm.bodyComponent, {
                                tag: "component",
                                attrs: {
                                  promo: _vm.promo,
                                  promo_request_id: _vm.$route.params.promo_id,
                                  "payment-falied": _vm.paymentFailed
                                },
                                on: {
                                  "set-status": _vm.setStatus
                                }
                              }),
                              _vm.completedMsg !== ""
                                ? _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.completedMsg)
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _c(
        "div",
        [
          _c(
            "v-card",
            {
              staticClass: "app-card"
            },
            [
              _c("v-card-title", [_vm._v(" Error ")]),
              _c("v-card-text", [_vm._v(" " + _vm._s(_vm.error) + " ")])
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }